import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import { Link } from 'gatsby';
import './design-guidelines-styles.css';
import { DemoModal } from '../../components/DemoModal';
import { LeadParagraph } from '../../components/LeadParagraph';
export const _frontmatter = {
  "pageTitle": "Modal Design Guidelines",
  "title": "Modal",
  "order": 1
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const PageContent = makeShortcode("PageContent");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

<PageContent componentName="modal" type="design" mdxType="PageContent">
<LeadParagraph mdxType="LeadParagraph">
  Modals inform users about a task and can contain critical information, require
  decisions, or involve multiple tasks.
</LeadParagraph>
<p><span parentName="p" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1035px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "60.61776061776062%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAIAAADtbgqsAAAACXBIWXMAAAsTAAALEwEAmpwYAAABXUlEQVQoz32S0W6CMBSGfU6dMVERmdx4M/ENNrMsWZh4bQwvsewlnInZFNgNiXNRFoWCIpT9tsrmhvsSmtOWj3NOaa7GEARBluV2u60oSqvVujoDtprNZu1IDk+9Xi8UCv1+3/M827ZXq1Ucx7s/hGFIaTIajQWh+i1LkpTP53Vdp5Q6jkMI2RwJGL7vI8aIFyzLqlZPZWQeDAb4/Hw+XywWH4zZbPbOQIAp1pMkMQwjW8aH1+s1aqZHYkYaQDZNM1vG9nK5dF0XpYaMtFuw3W4hTyaTbBl7MNO0mKJVXgviKIr+KxtJ0Bje5pmRCofnOKgFKzgtLk9/yzhtnhk+bzJhIAiCnR+Em030Ov0038jw+QXXIuNXpbX9xCOUEOp60e396Ppu/Pg0bFyKuFQHWRTFSqWCu9Xr9VRVfTil2+1qGoZ9rGlap3PDzYPM/XK5jM4vzlMs7sdSqZRezy8Ig+8xedwEfwAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": " ",
            "title": " ",
            "src": "/version/3.11.0/static/63f781efbfdefd5014fd1350b362c92d/e3189/modal-example-intro.png",
            "srcSet": ["/version/3.11.0/static/63f781efbfdefd5014fd1350b362c92d/a2ead/modal-example-intro.png 259w", "/version/3.11.0/static/63f781efbfdefd5014fd1350b362c92d/6b9fd/modal-example-intro.png 518w", "/version/3.11.0/static/63f781efbfdefd5014fd1350b362c92d/e3189/modal-example-intro.png 1035w", "/version/3.11.0/static/63f781efbfdefd5014fd1350b362c92d/44d59/modal-example-intro.png 1553w", "/version/3.11.0/static/63f781efbfdefd5014fd1350b362c92d/913b9/modal-example-intro.png 1822w"],
            "sizes": "(max-width: 1035px) 100vw, 1035px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span></p>
<hr></hr>
<h2>{`Usage`}</h2>
<p>{`A modal is intentionally interruptive and blocks the user from interacting with the on-page content. Modals keep the user focused on the task or information until they either cancel or complete the task. Modals can be very useful when used effectively but should be used sparingly to avoid disrupting the user too much. Here are some guidelines for when to use a modal.`}</p>
<h3>{`Confirm a User Decision`}</h3>
<p>{`Clearly describe the decision being made by the user, and explain any possible consequences it could cause. The primary button should also reinforce the action being taken. If the action being taken is irreversible, make that clear to the user as well. The user should also be able to cancel the action with a secondary button or closing the modal.`}</p>
<span {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1035px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "52.123552123552116%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAIAAAA7N+mxAAAACXBIWXMAAAsTAAALEwEAmpwYAAAA4klEQVQoz6WRzQqCQBCAfU47aGqtnjx68KoIXexkUhGdAjNPnT1kT9BDdPAfRFs6yDYFhUk/Rh8sw7DzzSw71PAZQRBkWbYsy7btyZ3pdKaqKsdxCKFmMdVM4I5lWcMwqqoqy7IoCoxxXdeEEM/zaJqWJOmLrGlalmVJkqRpCgciyK7rdpT1PM/jOA7DCObjU/WDrOt6fYVgTKL4rI0Oy9XRcTa9Hi2KH2We5xVFCYJgf8P3d/PFdu36pjlmGAYh8a38+HDmDjwEDbmB0Iem0LxV+UIGxAaQwcDWkj7JHflLvgBhaCN5Fo4KjgAAAABJRU5ErkJggg==')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "",
          "title": "",
          "src": "/version/3.11.0/static/6c39c0ee5172425465149533af3cec6c/e3189/confirm-decision.png",
          "srcSet": ["/version/3.11.0/static/6c39c0ee5172425465149533af3cec6c/a2ead/confirm-decision.png 259w", "/version/3.11.0/static/6c39c0ee5172425465149533af3cec6c/6b9fd/confirm-decision.png 518w", "/version/3.11.0/static/6c39c0ee5172425465149533af3cec6c/e3189/confirm-decision.png 1035w", "/version/3.11.0/static/6c39c0ee5172425465149533af3cec6c/44d59/confirm-decision.png 1553w", "/version/3.11.0/static/6c39c0ee5172425465149533af3cec6c/913b9/confirm-decision.png 1822w"],
          "sizes": "(max-width: 1035px) 100vw, 1035px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span>
<h3>{`Edit or Manage Tasks`}</h3>
<p>{`It's very common to use a modal to quickly edit or manage one or more items on a page without going back and forth between multiple pages. The emphasis here is "quickly". If the settings or management of an item becomes relatively complex and requires many decisions or multiple steps, please consider using a separate page or something other than a modal. If a particular action is often done repeatedly, consider allowing the action to be done directly on the main page rather than in a modal.`}</p>
<span {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1035px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "66.79536679536679%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAIAAAAmMtkJAAAACXBIWXMAAAsTAAALEwEAmpwYAAABX0lEQVQoz3WSzU7CQBSFeU4Im4a2Q0kMC13wCrg1IF0Z2vAAookLl8aFC3dK6B914aKLEqC/M22n3jJKADtf0smkvWfumdPbkCRJlmVBEAaDgaqq4/H4ls9kog6H16IoSnsa8HS73WazOZvNyrLcbDZJkpR1UEphXa3cTqdzIm61WpqmFUXh+z7GuKgjz3MQW5ZVL4ZvcRxnHAghUGAYxrkYbOu6zmxTDqyzbdvczmEY5hygORSYpskVw92OEqoJrMb2QQwX20dTQWkB3WDD0iIk2wd22hkhxMRQutvtQM9MhhEOggDepCnOKjFJUrpYGKL4TzydTuHg7XYL/xnqMCbrdZgkaRRFaRrDaWAECpbLZU3abEhYpGdkWXXbx6fvm4n98rpQFInN2G/ndrs9Go08z3Mc5+sP13VhhZH6+LRM05k/vN9pb/fzZyQfiQ8gDooC5lC/37u6vOgp6DDbP/nxNVIufXLTAAAAAElFTkSuQmCC')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "",
          "title": "",
          "src": "/version/3.11.0/static/2d324380c92c0f80081e7052499783e5/e3189/edit-item-example.png",
          "srcSet": ["/version/3.11.0/static/2d324380c92c0f80081e7052499783e5/a2ead/edit-item-example.png 259w", "/version/3.11.0/static/2d324380c92c0f80081e7052499783e5/6b9fd/edit-item-example.png 518w", "/version/3.11.0/static/2d324380c92c0f80081e7052499783e5/e3189/edit-item-example.png 1035w", "/version/3.11.0/static/2d324380c92c0f80081e7052499783e5/44d59/edit-item-example.png 1553w", "/version/3.11.0/static/2d324380c92c0f80081e7052499783e5/913b9/edit-item-example.png 1822w"],
          "sizes": "(max-width: 1035px) 100vw, 1035px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span>
<hr></hr>
<h2>{`Sizes`}</h2>
<p>{`Modals come in three responsive sizes: small, medium, and large.`}</p>
<span {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1035px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "63.70656370656371%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAIAAAAmMtkJAAAACXBIWXMAAAsTAAALEwEAmpwYAAABoklEQVQoz2VSy07CQBTtfxIKfUALtKG8Ah0lJhh2bIiP+AcEdyaGIAtNXLiBNFADNLDRRI0/wKZS8TAD0yJnMY/ec3vvOXeENIWmaelDqKoaj8djsZiiKMdRBoFtYICdogAV13K53O12e737kxMiyzI+IsQ4bN0mY9N1vVKplEqlQqFgWRa+JBKJZrO5XgebzabdbouiCGo+n2cE27ZzuRxou8qGYeCezWYzmQyukiQRYjvOuHP7YpMzWZagDDVAwAoy1rBtlYK1HXWB0naCU3uEbTMeo/IDYoPBwHEc130djoYohQSdgnO2yThVq1XI4JJYF4vFIggC/+f37f3bsvLwDKFisQhrCCH43U4z/yXvFpr7/Yfl0nt8Gl7f3JlmDsPgBE4WuJ7oAGEbtUTDbhpZ8Hko6osQzUECatbr9dlsNhqNPM9D8/O59/X50Wq1kslktMcwuVar4VVAD2o2Gg2Md7Va+b6PA1W+ubi8QhYIkA3NpmmGc9b3oBMm0+l0PB5PJhPXdeF5p/t8Wj9XFFnbu/1fM1cCq8VDqKqE6R6/7T/ByG4qoWHzbgAAAABJRU5ErkJggg==')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "",
          "title": "",
          "src": "/version/3.11.0/static/9e77a8de4ea35f266c1ab2e79c2912fb/e3189/modal-sizes.png",
          "srcSet": ["/version/3.11.0/static/9e77a8de4ea35f266c1ab2e79c2912fb/a2ead/modal-sizes.png 259w", "/version/3.11.0/static/9e77a8de4ea35f266c1ab2e79c2912fb/6b9fd/modal-sizes.png 518w", "/version/3.11.0/static/9e77a8de4ea35f266c1ab2e79c2912fb/e3189/modal-sizes.png 1035w", "/version/3.11.0/static/9e77a8de4ea35f266c1ab2e79c2912fb/c1b63/modal-sizes.png 1200w"],
          "sizes": "(max-width: 1035px) 100vw, 1035px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span>
<h3>{`Small`}</h3>
<p>{`The default width of the small modal is 300px. Works well for basic alerts and confirmations.`}</p>
<DemoModal size="small" mdxType="DemoModal" />
<h3>{`Medium`}</h3>
<p>{`The default width of the medium modal is 600px. Works well for standard single-column forms.`}</p>
<DemoModal size="medium" mdxType="DemoModal" />
<h3>{`Large`}</h3>
<p>{`The default width of the large modal is 900px. Works well for UI's requiring multi-column layouts. If you are considering the large modal, you should also be seriously considering using a new page instead.`}</p>
<DemoModal size="large" mdxType="DemoModal" />
<h3>{`Modal Height`}</h3>
<p>{`React Magma modals do not have a maximum height at this time. They are as tall as they need to be to fit the content, which means it's possible for the bottom of the modal to extend beyond the bottom of the viewport. You can still easily scroll the entire modal in order to access the content off-screen.`}</p>
<h3>{`Responsive Behavior`}</h3>
<p>{`When the viewport of the device is 600px wide or below, the padding within the modal decreases from 24px to 16px. This matches the change in gutter widths on the overall page layout on smaller devices. The result allows the content of the modal to maximize the available space.`}</p>
<hr></hr>
<h2>{`Behaviors`}</h2>
<h3>{`Trigger`}</h3>
<p>{`Modals are typically triggered by a user's action rather than generated by the system. Common components used to trigger a modal include buttons, links, and icons. A modal can also be opened using a keyboard by pressing `}<inlineCode parentName="p">{`Enter`}</inlineCode>{` or `}<inlineCode parentName="p">{`Space`}</inlineCode>{`.`}</p>
<h3>{`Closing`}</h3>
<p>{`Modals should always contain a way to close them, and there are typically multiple ways for any modal. The most obvious is the Close button in the upper-right corner. Less obvious, but always present, is the ability to press `}<inlineCode parentName="p">{`Escape`}</inlineCode>{` on the keyboard or simply click outside the modal. Additionally, there is often a primary action button that triggers a process and then closes the modal when it's completed or a Cancel button that closes the modal without taking any further action.`}</p>
<h3>{`Focus`}</h3>
<p>{`When a modal is opened, the focus is automatically put on the title of the modal rather than the first actionable element. We intentionally do this to provide an optimal experience for both people using assistive technologies and those who don't.`}</p>
<span {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1035px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "40.54054054054054%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAICAIAAAB2/0i6AAAACXBIWXMAAAsTAAALEwEAmpwYAAAA/0lEQVQY03WQy26DMBBF852whQg2rNJVgH4LQvxSVChQqSvsQKnxi5dNR1hJpYpeja9mxjrjx+m8y3XdIAhe4ziOoigMw+v1MECXy8v5oRMsz/Ns206SpCP0/eMTfX2zeR3kTCFGEws4kZPattvtzXGcX9j3fcuysixblcZtRwbKhaRCMHDGoRgY43IcGFda13X9F4aT0zRdlgUj1LbtfRdqGoQgwJo7xtDftq0sy2NYKUUIAddaP90kJge4qqp/4a7rKKVSynnXssvk0zQBXBTFMQx7QOqHoBzH0XQgX9f14NrmtwGG8RhjuLkQYtrFGIPH933POYdBMCXP8yf8A+OkXnFxhJeuAAAAAElFTkSuQmCC')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "",
          "title": "",
          "src": "/version/3.11.0/static/daa8fad529227faa05558e8b72e01a15/e3189/modal-focus-example.png",
          "srcSet": ["/version/3.11.0/static/daa8fad529227faa05558e8b72e01a15/a2ead/modal-focus-example.png 259w", "/version/3.11.0/static/daa8fad529227faa05558e8b72e01a15/6b9fd/modal-focus-example.png 518w", "/version/3.11.0/static/daa8fad529227faa05558e8b72e01a15/e3189/modal-focus-example.png 1035w", "/version/3.11.0/static/daa8fad529227faa05558e8b72e01a15/44d59/modal-focus-example.png 1553w", "/version/3.11.0/static/daa8fad529227faa05558e8b72e01a15/913b9/modal-focus-example.png 1822w"],
          "sizes": "(max-width: 1035px) 100vw, 1035px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span>
<h3>{`Validation`}</h3>
<p>{`Always validate a user's input entries before a modal is closed. If there are any errors, an inline error alert should be displayed above the form, as well as error messages on any specific inputs that failed validation. The error messages should provide clear instructions on how to resolve the errors and complete the action.`}</p>
<span {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1035px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "66.40926640926641%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAIAAAAmMtkJAAAACXBIWXMAAAsTAAALEwEAmpwYAAABvElEQVQoz3VSTW/aQBDN7zScEBhbnCqMWg79OKc/gFCIFAnEOYemv6CqeqjUS1spApSWOEQY2+tP6vXOevsc0ghI8vRmNLL0/GZn5kjX9WazWavVut3uYDDo9Xonz6Pf/3B8/L7RaOh3OEKYpqlp2mQyUUoxxjjn6ikURYF8dfW7Xq/viSuaNhqNSAjHcXyAgQjf8zzE2nVZEKDGf2ez6SNxpQKxIFqtVv6dCMndYr0GPdcNGIPzfD7fFxsG2h6Px+rG5vMZLW/y64VYLPLFHwEul9J1QbF2VMCmP3/U995sGGXbECdxaNu571MYUhAQ88scRTJJQIpjJfLZ5eWh87btgnPndhkHjHhW5Pk9Od9SZhmG9oz47EwFvghhFcJZpqmSUhGVRCGpoLx883R/YMbOwDAnIQRJKYsSaZpiyBnnRJLnBPH0UPy/bXQFcRRFm80GW8myDEUchUlSfikKCfETq3o4EiI6uA2cDPg3k+cfF+cXt1++/jINfTvve+dqtTocDmGFvfo7cF3Pth3w2nb6p99Oht8vPn02zR0xgHNttVqWZbUfoWO1Ox2rY1lvXr989/ZVu/3i4bb/AZBcMKN8dQ+PAAAAAElFTkSuQmCC')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "",
          "title": "",
          "src": "/version/3.11.0/static/6471e07bf77a7a84a5912b891b7a9c38/e3189/modal-validation.png",
          "srcSet": ["/version/3.11.0/static/6471e07bf77a7a84a5912b891b7a9c38/a2ead/modal-validation.png 259w", "/version/3.11.0/static/6471e07bf77a7a84a5912b891b7a9c38/6b9fd/modal-validation.png 518w", "/version/3.11.0/static/6471e07bf77a7a84a5912b891b7a9c38/e3189/modal-validation.png 1035w", "/version/3.11.0/static/6471e07bf77a7a84a5912b891b7a9c38/44d59/modal-validation.png 1553w", "/version/3.11.0/static/6471e07bf77a7a84a5912b891b7a9c38/913b9/modal-validation.png 1822w"],
          "sizes": "(max-width: 1035px) 100vw, 1035px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span>
</PageContent>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      